import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { setErrorMessage } from '../../store/slices/coreSlice';
import { PartRequestLineHasInvoiceError } from '../enums/errorsEnum';
import { ServerErrorType, VoidFunctionType } from '../types/coreTypes';

export const partRequestLineHasInvoiceErrorHandler = (
  errors: ServerErrorType[],
  dispatch: ThunkDispatch<unknown, unknown, AnyAction>,
  closeModal: VoidFunctionType,
) => {
  const partRequestLineHasInvoiceErrors = errors.filter(
    (el) => el.key === PartRequestLineHasInvoiceError,
  );
  if (partRequestLineHasInvoiceErrors?.length) {
    partRequestLineHasInvoiceErrors.forEach(({ message }) => dispatch(setErrorMessage({ message, toastId: Math.random() })));
    closeModal();
  }
};
